import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './routes';
import { initializeI18next } from './plugins/i18next';
import { Provider } from 'react-redux';
import { StyledEngineProvider, ThemeProvider, useTheme } from '@mui/material/styles';
import store, { useDispatch } from './store';
import { setScreenSizeAction } from '@reducers/global';
import useWidth from '@hooks/useWidth';
import { jsx as _jsx } from "react/jsx-runtime";
function App() {
    var dispatch = useDispatch();
    var theme = useTheme();
    var width = useWidth();
    useEffect(function () { initializeI18next(); var vh = window.innerHeight * 0.01; document.documentElement.style.setProperty('--vh', "".concat(vh, "px")); var setCustomVh = function setCustomVh() { document.documentElement.style.setProperty('--vh', window.innerHeight / 100 + 'px'); }; window.addEventListener('resize', setCustomVh); return function () { window.removeEventListener('resize', setCustomVh); }; }, []); // 스크린 사이즈 및 화면 방향 정보 저장
    useEffect(function () { dispatch(setScreenSizeAction(width, window.screen.orientation)); }, [document.body.clientWidth]);
    useEffect(function () {
        var data = []; // const ids = [
        // 	'4hQ1aCjwiEd13j8ZMaqA',
        // 	'5IAYlERYzpqxj3ORV4zE',
        // 	'5PAXMNKGCpntuWAVmQgZ',
        // 	'7drQiNMAluqH97V0LDuL',
        // 	'8JEwsD8BtBQsWh1gMSBZ',
        // 	'BPbQlENwpufH0FmcwoGZ',
        // 	'DQWh8EB1IJvwbqyvnOot',
        // 	'EYd9JZ0WhNH1vaT51pbE',
        // 	'MSkIbn6JCUQeLlWoYYPd',
        // 	'Vtv4fFFmGePp9RDDJW3A',
        // 	'aaC7Yahy5WQjKIM0GOQw',
        // 	'aphUX7t6RmBWf3KRuKRc',
        // 	'baFLptmYOoeNnwQ6hj32',
        // 	'dgPNDhyFaGnhhgDI0SUO',
        // 	'iX6qei2NPzddiF2hRnsq',
        // 	'icVrDmniW5hKKvbyx5CF',
        // 	'lgUJoEYxbzDZr9Qs8b7y',
        // 	'mxr2tgJhSE1lHJGBzUBN',
        // 	'nCX6eyEogozRvzTJFP5x',
        // 	'w4npM0QPAQsZcw3OjgbA',
        // 	'zhwaGsPV1CYklhiGeAt3',
        // ];
        // const promises = ids.map(id => {
        // 	return firestore()
        // 		.collection('Logs')
        // 		.doc(id)
        // 		.collection('ViewLogs')
        // 		.orderBy('createdAt', 'asc')
        // 		.get()
        // 		.then(querySnapshot => {
        // 			let csv = 'createdAt,exhibitionId,exhibitionTitle,viewCount\n';
        // 			querySnapshot.forEach(doc => {
        // 				const { createdAt, exhibitionId, exhibitionTitle, viewCount } = doc.data();
        // 				data.push({ createdAt, exhibitionId, exhibitionTitle, viewCount });
        // 				csv += `${createdAt},${exhibitionId},${exhibitionTitle},${viewCount}\n`;
        // 			});
        // 		});
        // });
        // Promise.all(promises).then(() => {
        // 	const csv =
        // 		'createdAt,exhibitionId,exhibitionTitle,viewCount\n' +
        // 		data
        // 			.sort((a, b) => a.createdAt - b.createdAt)
        // 			.map(
        // 				({ createdAt, exhibitionId, exhibitionTitle, viewCount }) =>
        // 					`${createdAt},${exhibitionId},"${exhibitionTitle}",${viewCount}`,
        // 			)
        // 			.join('\n');
        // 	console.log(csv);
        // });
    }, []);
    return /*#__PURE__*/ _jsx(BrowserRouter, { children: /*#__PURE__*/ _jsx(Provider, { store: store, children: /*#__PURE__*/ _jsx(StyledEngineProvider, { injectFirst: true, children: /*#__PURE__*/ _jsx(ThemeProvider, { theme: theme, children: /*#__PURE__*/ _jsx(AppRouter, {}) }) }) }) });
}
export default App;
